import { render, staticRenderFns } from "./TransactionEditFormDefault.vue?vue&type=template&id=6c51643e&"
import script from "./TransactionEditFormDefault.vue?vue&type=script&lang=js&"
export * from "./TransactionEditFormDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports